import { Apartment, Agent, Service, FAQ } from '../types';

export const INITIAL_SALES: Apartment[] = [];

export const INITIAL_RENTALS: Apartment[] = [];

export const INITIAL_AGENTS: Agent[] = [];

export const INITIAL_SERVICES: Service[] = [
  {
    id: 'sec-1',
    title: 'ПОСРЕДНИЧЕСТВО ПРИ СДЕЛКА',
    description: 'Професионално посредничество при покупко-продажба и отдаване или наемане на имоти. Ние защитаваме Вашите интереси и Ви осигуряваме сигурност.',
    icon: 'Handshake',
    details: [
      'Маркетинг и реклама на Вашата оферта в най-големите платформи',
      'Провеждане на огледи от обучени топ брокери',
      'Осигуряване на реален пазарен интерес и филтрация на сериозни купувачи',
      'Финансови преговори за достигане на максимална пазарна цена'
    ]
  },
  {
    id: 'sec-2',
    title: 'ПОДГОТОВКА НА ДОКУМЕНТИ',
    description: 'Пълно правно и документално проучване на имоти, за да се гарантира изрядността на сделката без скрити рискове.',
    icon: 'FileText',
    details: [
      'Изготвяне на Предварителни договори по ЗЗД',
      'Проверка за вещни тежести, ипотеки, съдебни спорове и възбрани',
      'Снабдяване с данъчни оценки, кадастрални схеми и удостоверения',
      'Координация с нотариус и подготовка на Нотариални актове'
    ]
  },
  {
    id: 'sec-3',
    title: 'КОНСУЛТАЦИИ И АНАЛИЗИ',
    description: 'Предоставяме детайлна картина за динамиката на пазара на имоти във Варна и областта, за да направите най-добрия избор за инвестиция.',
    icon: 'TrendingUp',
    details: [
      'Безплатни първоначални пазарни оценки',
      'Актуални статистически анализи на цените по райони и квартали',
      'Инвестиционни съвети с изчисление на възвръщаемост (ROI) на наеми',
      'Консултация за кредитиране - партньорство с водещи банки за супер лихви'
    ]
  },
  {
    id: 'sec-4',
    title: 'СЪДЕЙСТВИЕ ДО КРАЙ',
    description: 'Първата ни среща е само началото. Ние стоим до Вас при фактическото предаване на имота, деклариране и допълнителни ангажименти.',
    icon: 'Heart',
    details: [
      'Физическо предаване на имота с приемо-предавателен протокол',
      'Смяна на партиди за ток, вода, Енерго-Про, ВиК и Топлофикация',
      'Помощ при деклариране в местната община и НАП',
      'Съвети при интериорен дизайн, ремонт или бъдещо управление'
    ]
  }
];

export const INITIAL_FAQS: FAQ[] = [
  {
    question: 'Какви услуги предлага Варна Имотен Център?',
    answer: 'Ние сме специализирана агенция от ново поколение, предлагаща посредничество при покупко-продажба на жилищни, търговски и промишлени имоти, сигурни дългосрочни наеми, безплатно съдействие за ипотечно кредитиране у нас, правна подготовка на документи и прецизна оценка на пазарното състояние на пазара във Варна.'
  },
  {
    question: 'Съдействате ли при набавянето на нужните документи за продажба?',
    answer: 'Да! Нашата правна секция изцяло поема набавянето на Удостоверения за тежести, кадастрални схеми от АГКК, данъчни оценки и всички други необходими документи за извършване на сигурна нотариална покупко-продажба.'
  },
  {
    question: 'Колко струва посредническата услуга?',
    answer: 'Стандартното комисионно възнаграждение се определя като процент от уговорената цена на имота за покупко-продажба или половин/един месечен наем при наемане. Всички подробности се договарят предварително прозрачно и ясно без скрити такси!'
  },
  {
    question: 'Как да пусна моя имот за продан или наем чрез вас?',
    answer: 'Можете лесно да се свържете с нас чрез страницата за Контакти, по телефон +359 878 859 385 или директно да оставите запитване. Нашият екип ще проведе консултация, ще изготви професионални снимки и ще качи веднага офертата в системата.'
  },
  {
    question: 'Гарантирана ли е сигурността на покупката при банково кредитиране?',
    answer: 'Напълно. Ние си сътрудничим с квалифицирани юристи и лицензирани кредитни консултанти. Подготвяме пълна документация, която банките изискват за юридическия одит, гарантирайки спокойна трансакция и преференциални лихвени проценти.'
  }
];

export const POPULAR_NEIGHBORHOODS = [
  { name: 'Бриз', count: 0, image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=450&fit=crop&q=80' },
  { name: 'Левски', count: 0, image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=450&fit=crop&q=80' },
  { name: 'Чайка', count: 0, image: 'https://images.unsplash.com/photo-1600573472591-ee6b68d14c68?w=450&fit=crop&q=80' },
  { name: 'Възраждане', count: 0, image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=450&fit=crop&q=80' },
  { name: 'Център', count: 0, image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=450&fit=crop&q=80' },
  { name: 'Виница', count: 0, image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=450&fit=crop&q=80' }
];

export const STOCK_GALLERY_IMAGES = [
  'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&auto=format&fit=crop&q=80',
  'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&auto=format&fit=crop&q=80',
  'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600&auto=format&fit=crop&q=80',
  'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&auto=format&fit=crop&q=80',
  'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&auto=format&fit=crop&q=80',
  'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&auto=format&fit=crop&q=80',
  'https://images.unsplash.com/photo-1600573472591-ee6b68d14c68?w=600&auto=format&fit=crop&q=80',
  'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&auto=format&fit=crop&q=80',
  'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=600&auto=format&fit=crop&q=80',
  'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=600&auto=format&fit=crop&q=80'
];
